<template>
    <div class="container">
        <h1>Qu'est-ce que ADA ?</h1>
        <p class="intro">
            Tout sur ADA, la cryptomonnaie de la blockchain Cardano.
        </p>

        <h2 id="distribution-de-ada">Distribution</h2>
        <p>
            ADA est actuellement classée comme la 9e cryptomonnaie en terme de capitalisation marché.
            31 millions d'ADA sont en circulation, pour un nombre de jetons maximum de 45 millions.

            Avec 3.2 milliards de dollars de capitalisation (au moment de l'article), le token (jeton) ADA se négocie actuellement autour des 0.1$.
        </p>

        <h2 id="fonctionnalites-de-ada">Les fonctionnalités de ADA</h2>
        <p>
            Ada possède toutes les caractéristiques classiques des cryptomonnaies (à savoir envoyer, recevoir de l'argent). Le token ADA est échangeable
            contre des euros ou des dollars sur tous les plus gros exchange (Binance, Crypto.com, Coinbase, Kraken, etc), et la grande majorité des petits
            également.
        </p>

        <p>
            Mais ça ne s'arrête pas là, vous pouvez <b>gagner des intérêts</b> sur vos jetons en participant au protocole de consensus de la
            blockchain Cardano, Ouroboros. En participant à la validation des transactions du réseau gràce au
            <a href="/doc-cardano/qu-est-ce-que-le-delegated-proof-of-stake-dpos" title="Qu'est ce que le delegated proof of stake (DPoS) ?">Delegated
                Proof of Stake</a>, vous pouvez espérer entre 4 et 8% par an, en moyenne.
        </p>

        <h2 id="progression-de-ada">la progression de ADA</h2>
        <p>
            Listée début 2018 par la plateforme Binance (le premier exchange), comme souvent lors d'une ICO d'un token "sérieux", le prix s'est d'abord
            envolé (à 0.4$) pour s'effondrer ensuite, conséquence de sa surévaluation évidente due à la grande quantité de spéculation
            qui entoure généralement les ICOs (introduction de token sur les marché).
        </p>

        <p>
            Début 2019, ADA, qui avait alors atteint son évaluation réelle, a alors pris le chemin de la progression logique qui suit les avancées
            du projet Cardano. Depuis cette date, la valeur du token a triplé (elle était même à x4 en Août dernier, avant le crash de Septembre).
        </p>

        <img v-lazy-load data-src="/img/adaprice.webp" alt="Progression du jeton ADA de 2017 à fin octobre 2020" title="Progression du jeton ADA" />

        <p class="mt-4">
            La force du token ADA se révèle particulièrement lorsqu'on zoom sur cette dernière période (début 2019 -> octobre 2020).
        </p>

        <img v-lazy-load data-src="/img/adapricerecent.webp" alt="Progression du jeton ADA de 2019 à fin octobre 2020" title="Progression du jeton ADA depuis 2019" />

        <p>
            En effet, le jeton semble posséder deux caractéristiques extrêmement importantes pour un projet de cryptomonnaie en bonne santé:
        </p>

        <ul>
            <li>Il se <b>remet rapidement des crash</b></li>
            <li>Il est en <b>progression</b> sur le long terme</li>
        </ul>

        <p>
            Pourquoi c'est, selon nous, très bon signe ? Parce que si la blockchain Cardano est déjà aujourd'hui un réseau stable et performant,
            <b>elle est encore loin d'avoir implémentée toutes ses fonctionnalités</b> !
        </p>

        <p>
            Le réseau déploie actuellement la phase <mark>Shelley</mark>, permettant de décentraliser les données, et rentrera bientôt dans sa phase
            <mark>Goguen</mark>, permettant d'établir les <mark>smart contracts</mark>, nécessaires pour partir à l'assaut du réseau Ethereum et de ses
            <b>42 milliards</b> de capitalisation marché !
        </p>

        <p>
            Si Ethereum <a href="https://cryptoast.fr/ethereum-problemes-defauts-limites/">qui n'en a pas fini avec ses problèmes de croissance</a>
            cède progressivement la place à ADA, les 42 milliards de capitalisation (qui continuent d'augmenter) due aux applications décentralisées
            et à la DeFI seront absorbés. Avec une capitalisation de 46 milliards, le jeton ADA serait projeté à plus d'un dollar,
            soit plus de 10x sa valeur actuelle.
        </p>

        <p>
            Difficile jusqu'où le jeton est destiné à monter, mais si les développements se déroulent comme prévu (comme toujours jusqu'ici), l'abordage
            d'Ethereum semble de plus en plus proche. Chez Stakepool.fr, nous sommes dans le bateau.
        </p>
    </div>
</template>

<script>
import createHeader from "../../js/meta.js";

export default {
    layout: "DocLayout",
    head: createHeader({
        title: "Qu'est-ce que ADA, la cryptomonnaie de Cardano - Stakepool.fr",
        description:
            "Quelles sont les fonctionnalités de cette cryptomonnaie ? Combien vaut-elle actuellement, et quelles sont les projections pour le futur ?"
    })
};
</script>